// ----------------------------------------------------------------------------
// Nombre del Programa : EstadisticasComunicados
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el el detalle de analitics
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { useEffect, useState } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { BotonRegresar } from '../../components/boton-regresar/BotonRegresar';
import {
  DatosGrafica,
  DetalleEstadisticasComunicado,
  EstadisticasComunicadoProps,
} from '../../interfaces/analiticosInterfaces';
import { apiRequestToken } from '../../Utilidades/apiRequest';
import { Graficos } from './Graficas';

//Modificacion: Marca de Inicio WII C-24-1229-24
export const EstadisticasComunicado = ({
  estadistica,
  fechaInicio,
  fechaFin,
  tipoSeleccionado,
  cerrarDetalle,
}: EstadisticasComunicadoProps) => {
  const [datosDia, setDatosDia] = useState<DatosGrafica[]>([]);
  const [datosHora, setDatosHora] = useState<DatosGrafica[]>([]);
  const [datosFecha, setDatosFecha] = useState<DatosGrafica[]>([]);
  const [detalle, setDetalle] = useState<DetalleEstadisticasComunicado>({
    adjuntos: [],
    links: [],
  });
  useEffect(() => {
    if (estadistica && fechaInicio && fechaFin) cargarDetalle();
  }, [estadistica, fechaInicio, fechaFin]);
  const cargarDetalle = async () => {
    let params = '';
    params += fechaInicio !== '' ? '&fechainicio=' + fechaInicio : '';
    params += fechaFin !== '' ? '&fechafin=' + fechaFin : '';
    const response: any = await apiRequestToken({
      endpoint: tipoSeleccionado === "1" ? `estadisticas/${estadistica.comunicado.comunicado_id}?${params}` : `estadisticasEnlaces/${estadistica.comunicado.comunicado_id}?${params}`,
      method: 'GET',
    }).catch(() => { });
    if (response.data?.data) {
      const { adjuntos, urls, datosPorDia, datosPorFecha, datosPorHora } =
        response.data.data;
      setDetalle({ adjuntos: adjuntos, links: urls });
      setDatosDia(datosPorDia);
      setDatosFecha(datosPorFecha);
      setDatosHora(datosPorHora);
    }
  };
  return (
    <>
      <Row className="mt-3">
        <Col>
          <BotonRegresar backHandler={cerrarDetalle}></BotonRegresar>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="h4 color-primary">{estadistica.comunicado.titulo}</Col>
      </Row>
      <Row className="mt-2">
        <Col className="h5 color-primary">
          Total de vistas: <b>{estadistica.vistas}</b>
        </Col>
      </Row>
      {tipoSeleccionado === "1" ? (
        <Row className="mt-3">
          <Col md={6}>
            <h5>Clics en link</h5>
            <Table responsive>
              <thead className="colorgray2">
                <tr>
                  <th>URL</th>
                  <th>Clics</th>
                </tr>
              </thead>
              <tbody>
                {detalle.links.map((adj) => {
                  return (
                    <tr className="colorgray2">
                      <td>{adj.dimension}</td>
                      <td>{adj.conteo}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
          <Col md={6}>
            <h5>Descarga de adjuntos</h5>
            <Table responsive>
              <thead className="colorgray2">
                <tr>
                  <th>Adjunto</th>
                  <th>Descargas</th>
                </tr>
              </thead>
              <tbody>
                {detalle.adjuntos.map((adj) => {
                  return (
                    <tr className="colorgray2">
                      <td>{adj.dimension}</td>
                      <td>{adj.conteo}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      ) : null}
      <Graficos
        datosDia={datosDia}
        datosFecha={datosFecha}
        datosHora={datosHora}
      ></Graficos>
    </>
  );
};
//Modificacion: Marca de Fin WII C-24-1229-24
